import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InvestigationDashboardRepository } from '../../../infrastructure/repositories/investigation-dashboard.repository';
import type { SetWatchInvestigationCommand } from './set-watch-investigation.command';
import type { SetWatchInvestigationResult } from './set-watch-investigation.result';

@Injectable({ providedIn: 'root' })
export class SetWatchInvestigationUseCase {
  private readonly _repository = inject(InvestigationDashboardRepository);

  public execute(command: SetWatchInvestigationCommand): Observable<SetWatchInvestigationResult> {
    return this._repository.setWatchInvestigation(command.investigationId, command.isWatching).pipe(
      map(() => ({
        success: true,
        investigationId: command.investigationId,
        isWatching: command.isWatching,
      })),
    );
  }
}
